export type GetSearchAttributesProps = {
  search: URLSearchParams;
};

export const getSearchAttributes = ({ search }: GetSearchAttributesProps) => {
  const attributes = {};

  if (search.has("interestQuery"))
    attributes["interestQuery"] = search.get("interestQuery");

  if (search.has("referrer")) attributes["referrer"] = search.get("referrer");

  if (search.has("utmCampaign"))
    attributes["utmCampaign"] = search.get("utmCampaign");

  if (search.has("utmMedium"))
    attributes["utmMedium"] = search.get("utmMedium");

  if (search.has("utmSource"))
    attributes["utmSource"] = search.get("utmSource");

  return attributes;
};
